/**
 * MW Bundle Builder renders the offer cart inside Shadow DOM. Global theme CSS cannot style it.
 * This script injects the same flex-order rules into each shadow root (and document) that contains
 * `.OfferCart-CartContent__CartContentContainer`.
 */
(function () {
  var MARK = 'data-mw-bundle-gifts-style';
  var CSS =
    '.OfferCart-CartContent__CartContentContainer{display:flex!important;flex-direction:column!important}' +
    '.OfferCart-CartContent__CartContentContainer>*{order:100!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--header{order:10!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--progressBarSection{order:20!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--giftsTitle{order:30!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--giftsContainer{order:40!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--giftsContainer+.CartContent-Boxes--divider{order:45!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-BoxSelector--grid{order:50!important}' +
    '.OfferCart-CartContent__CartContentContainer>div.mb-4{order:60!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--divider{order:70!important}' +
    '.OfferCart-CartContent__CartContentContainer>.CartContent-Boxes--priceSection{order:80!important}' +
    '.CartContent-Gift--withPadding{padding-bottom:0!important}' +
    '.CartContent-Boxes--giftsContainer{margin-bottom:0!important}';

  function appendStyle(targetParent) {
    if (!targetParent || targetParent.querySelector('style[' + MARK + ']')) {
      return;
    }
    if (!targetParent.querySelector('.OfferCart-CartContent__CartContentContainer')) {
      return;
    }
    var s = document.createElement('style');
    s.setAttribute(MARK, '1');
    s.textContent = CSS;
    targetParent.appendChild(s);
  }

  function injectDocument() {
    if (!document.querySelector('.OfferCart-CartContent__CartContentContainer')) {
      return;
    }
    if (document.head.querySelector('style[' + MARK + ']')) {
      return;
    }
    var s = document.createElement('style');
    s.setAttribute(MARK, '1');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /** Document mutations do not bubble from shadow trees; observe each root we find. */
  var observedShadowRoots = new WeakSet();
  function observeShadowRoot(root) {
    if (!root || observedShadowRoots.has(root)) {
      return;
    }
    observedShadowRoots.add(root);
    var mo = new MutationObserver(schedule);
    mo.observe(root, { childList: true, subtree: true });
  }

  function walkShadow(node) {
    if (!node || node.nodeType !== 1) {
      return;
    }
    if (node.shadowRoot) {
      observeShadowRoot(node.shadowRoot);
      appendStyle(node.shadowRoot);
      walkShadowDeep(node.shadowRoot);
    }
    var ch = node.children;
    for (var i = 0; i < ch.length; i++) {
      walkShadow(ch[i]);
    }
  }

  function walkShadowDeep(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      if (el.shadowRoot) {
        observeShadowRoot(el.shadowRoot);
        appendStyle(el.shadowRoot);
        walkShadowDeep(el.shadowRoot);
      }
    }
  }

  var rafScheduled = false;
  function schedule() {
    if (rafScheduled) {
      return;
    }
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      run();
    });
  }

  function run() {
    injectDocument();
    walkShadow(document.documentElement);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  document.addEventListener('shopify:section:load', schedule);
  [50, 200, 800].forEach(function (ms) {
    setTimeout(schedule, ms);
  });

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
